export default __webpack_public_path__ + "static/media/preview.2ce58f66.webp";